/*
    Copyright (C) 2023 - LMS2MTX - Southwest Airlines
*/
import { ACCESS_TOKEN_KEY } from "../../utilities/Constants";

export async function logout() {
  try {
    const url = process.env.REACT_APP_API_URL + "/auth/logout";
    const requestHeader = {
      ACCESS_TOKEN: JSON.parse(sessionStorage.getItem(ACCESS_TOKEN_KEY))
        .accessToken,
    };
    const request = {
      method: "POST",
      headers: requestHeader,
    };
    const response = await fetch(url, request);
    const json = await response.json();
    if (json.statusCode !== 200) {
      throw new Error("STATUS: " + json.statusCode);
    }
    sessionStorage.clear();
    return json;
  } catch (error) {
    return {
      statusCode: 500,
      body: {
        message: error.message,
      },
    };
  }
}
